import notificationsService from './notificationsService'

export default notificationsService



// WEBPACK FOOTER //
// ../src/services/notificationsService/index.js